<template>
  <div>
    <slot name="warningText" />
    <div class="row q-mt-lg">
      <BaseButton
        v-if="canRequestMediaItem"
        class="full-width"
        color="primary"
        :label="$t('modals.instant_download_warning.request_media_item')"
        new-design
        @click="$emit('media-item-button-clicked')"
      />
      <BaseButton
        v-else-if="canRequestTranscript"
        class="full-width"
        color="primary"
        :label="$t('modals.instant_download_warning.request_transcript')"
        new-design
        @click="$emit('transcript-button-clicked')"
      />
    </div>
  </div>
</template>

<script>
import { BaseButton } from "shared/components/base";

export default {
  name: "InstantDownloadWarning",
  components: {
    BaseButton,
  },
  props: {
    canRequestMediaItem: {
      type: Boolean,
    },
    canRequestTranscript: {
      type: Boolean,
    },
  },
  emits: ["media-item-button-clicked", "transcript-button-clicked"],
};
</script>

<style lang="scss" scoped>
.main {
  min-height: 325px;
}

.media-item-card {
  width: 300px;
  margin: 0 auto;
  box-shadow: none;
}
</style>
